import { Popconfirm as AntdPopconfirm, PopconfirmProps } from 'antd';

type IPopConfirmProps = PopconfirmProps;

export const PopConfirm = (props: IPopConfirmProps) => <AntdPopconfirm {...props} />;
